import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fafffc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "SellerShop"
}
const _hoisted_2 = { class: "user" }
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "statistic" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "浏览", -1))
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "经营", -1))
const _hoisted_12 = { class: "action" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("关注")
const _hoisted_14 = { class: "name" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "detail" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "price" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "￥", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/株", -1))
const _hoisted_22 = { class: "address" }
const _hoisted_23 = { class: "actions" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("打电话给他")
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_26 = { class: "telNum" }
const _hoisted_27 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanTab = _resolveComponent("VanTab")!
  const _component_VanTabs = _resolveComponent("VanTabs")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (Object.keys($setup.detail).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_VanImage, {
              src: $setup.detail.information.avatarUrl,
              fit: "cover",
              width: "72",
              height: "72",
              round: ""
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString($setup.detail.flows), 1),
                  _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString($setup.detail.operating), 1),
                  _hoisted_11
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_VanButton, {
                  size: "small",
                  color: "#EDDEB1",
                  round: "",
                  block: "",
                  style: {"color":"#74420D"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString($setup.detail.information.nickName), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["varieties", {isCollapse:$setup.isCollapse}])
        }, [
          _createVNode(_component_VanTabs, {
            "title-active-color": "#19be6b",
            color: "#19be6b",
            active: $setup.getListData.categoryId,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.getListData.categoryId) = $event)),
            onChange: $setup.search
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VanTab, {
                title: "全部",
                name: ""
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.varieties, (item) => {
                return (_openBlock(), _createBlock(_component_VanTab, {
                  title: item.value,
                  name: item.key
                }, null, 8, ["title", "name"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["active"])
        ], 2),
        _createVNode(_component_VanList, {
          class: "list",
          listLoading: $setup.loading,
          "onUpdate:listLoading": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
          onLoad: $setup.getList,
          "immediate-check": false,
          finished: $setup.finished
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item",
                key: idx,
                onClick: ($event: any) => ($setup.toSupplyDetail(item.id))
              }, [
                _createVNode(_component_VanImage, {
                  src: item.photos[0],
                  height: "12rem",
                  width: "100%",
                  fit: "cover"
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createTextVNode(_toDisplayString(item.minPrice), 1),
                      _hoisted_21
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(item.address), 1)
                ])
              ], 8, _hoisted_15))
            }), 128))
          ]),
          _: 1
        }, 8, ["listLoading", "finished"]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_VanButton, {
            color: "#FFCC32",
            round: "",
            block: "",
            onClick: $setup.getTel
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          })
        ]),
        _createVNode($setup["RestrictDialog"], {
          modelValue: $setup.restrictShow,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.restrictShow) = $event)),
          code: $setup.restrictCode,
          type: "supply"
        }, null, 8, ["modelValue", "code"]),
        _createVNode(_component_VanPopup, {
          class: "callDialog",
          show: $setup.isShowTel,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowTel) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, "是否拨打 " + _toDisplayString($setup.tel), 1),
            _createElementVNode("a", {
              class: "call",
              href: `tel:${$setup.tel}`
            }, "立即呼叫", 8, _hoisted_27)
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}